import { Scale } from "../../MyHelpers";
import { IReadOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SlotGameType1_2_2Screen } from "../SlotGameType1_2_2Screen";

export class Catillionare2_2Screen extends SlotGameType1_2_2Screen
{
    public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
       await super.ResourcesLoaded(loadingStage, resourceManager);

        if (loadingStage != LoadingStage.Games) {
            return;
        }
        this.title.style.width = Scale.Wpx(897);
        this.title.style.height = Scale.Wpx(637);
        this.title.style.backgroundSize = "contain";
    }

}